module.exports = __webpack_public_path__ + "static/media/YouthFocus.94253e6f.svg";